import { useSelector } from 'react-redux';
import { ReduxState } from '../store';
import { RoutingPage } from '../routes/routerSlice';

const usePage = (): RoutingPage | undefined => {
  return useSelector((state: ReduxState) => state.routerReducer.page);
};

export default usePage;
